import React from 'react';

function VideoSection() {
  return (
    <section id="vsl" style={{ paddingTop: 0 }}>
      <div className="wrap">
        <div className="sec-head">
          <div className="eyebrow">Watch · 2 min</div>
          <h2>Salesyo in real conditions</h2>
          <p>On a real client account. No marketing slides.</p>
        </div>
        <div className="vsl-box">
          <iframe
            src="https://www.youtube.com/embed/WEf-k-rmJmI"
            title="Salesyo demo"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default VideoSection;
